import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Tabs, { Tab } from '../../../../../../components/Tabs';
import { changeDetails } from '../../../../../../redux/dashboard-completed';
import { getDashboardCompletedPeriodTabs, getDashboardCompletedPeriodListUI } from '../../../../../../redux/selectors';

import './styles.css';

class DashboardCompletedPeriodTabs extends Component {
  componentDidUpdate(prevProps) {
    const { periodListUI, periodTabs, range } = this.props;

    if (
      // set first tab as active when periodList is updated
      ((periodListUI.received !== prevProps.periodListUI.received) && periodTabs[0]) ||
      // or when tab range changes
      ((range !== prevProps.range) && periodTabs[0])
    ) {
      this._changeComparativeRange(periodTabs[0]);
    }
  }

  _changeComparativeRange = (periodTab) => {
    const { rangeId, initialReferenceDate, finalReferenceDate } = periodTab;
    this.props.dispatch(changeDetails(rangeId, moment(initialReferenceDate).format('YYYY-MM-DD'), moment(finalReferenceDate).format('YYYY-MM-DD')));
  }

  render() {
    const { periodTabs, currentRangeId, isLoading } = this.props;

    if (!isLoading) {
      return (
        <Tabs classic fill className="PeriodTabs__Tab">
          {
            periodTabs.map(tab => (
              <Tab
                key={tab.rangeId}
                isActive={currentRangeId === tab.rangeId}
                onClick={() => { this._changeComparativeRange(tab); }}
              >
                {`${moment(tab.initialReferenceDate).format('DD/MM')} a ${moment(tab.finalReferenceDate).format('DD/MM')}`}
              </Tab>
            ))
          }
        </Tabs>
      );
    }
    return null;
  }
}

// redux
const mapStateToProps = state => ({
  range: state.dashboardCompleted.details.range,
  periodListUI: getDashboardCompletedPeriodListUI(state),
  periodTabs: getDashboardCompletedPeriodTabs(state),
  currentRangeId: state.dashboardCompleted.details.currentRangeId,
});

export default connect(mapStateToProps)(DashboardCompletedPeriodTabs);
